import _ from 'lodash'

export const ObjectLength = (obj) => {
  if (obj) {
    const keyArr = Object.keys(obj);
    return keyArr.length;
  }

  return null;
}

export const isObjectEqual = (objectA, objectB) => {
  _.isEqual(objectA, objectB);
}

export const deepEqual = (x, y) => {
  const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && tx === 'object' && tx === ty ? (
    ok(x).length === ok(y).length &&
    ok(x).every(key => deepEqual(x[key], y[key]))
  ) : (x === y);
}